import styled from 'styled-components';

type Props = {
  color?: string,
  onClick: () => void,
} & typeof defaultProps;

const defaultProps = {
  color: '#CBCBCA',
};
const SVGWrapper = styled.svg`
 cursor: pointer;
 &:hover {
   circle {
     fill: #565656;
   }
 }
 `;
const SliderCircledBackIcon = function SliderCircledBackIcon(props: Props) {
  const { color, onClick } = props;
  return (
    <SVGWrapper xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" className="slider-circled-back-icon" onClick={onClick}>
      <circle cx="12" cy="12" r="12" fill={color} />
      <path d="M8.39254 12.116C8.4003 11.8772 8.49382 11.6496 8.65534 11.4765L13.2423 6.60461C13.6084 6.21614 14.2141 6.20387 14.5951 6.57721C14.9761 6.95055 14.9881 7.56812 14.622 7.95659L10.6741 12.1525L14.622 16.3485C14.9881 16.7369 14.9761 17.3545 14.5951 17.7278C14.2141 18.1012 13.6084 18.0889 13.2423 17.7004L8.65534 12.8285C8.47661 12.6372 8.38177 12.38 8.39254 12.116Z" fill="white" />
    </SVGWrapper>
  );
};
SliderCircledBackIcon.defaultProps = defaultProps;
export default SliderCircledBackIcon;
